import { StringValues } from '../interfaces/undetermined';

// Constante que guarda el nombre de los atributos que recibe el API de los indicadores de redes, segun nombre en los formularios
export const NETWORKS: StringValues = {
    enFulfillment: "fulfillment",
    firstRange: "firstRange",
    lastRange: "lastRange",
    indicatorType: "type",
    variable: "variable",
    enResult: "result",
    startAt: "startAt",
    indicator: "ind",
    operation: "ope",
    enMonth: "month",
    params: "params",
    process: "proc",
    enYear: "year",
    enType: "type",
    enGoal: "goal",
    data: "data",
};
